import { Component, Inject } from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { TranslationKeyMap } from '../coaching-observation.i18n';

import { ObservationMandatoryFieldsDialogItem } from './observation-mandatory-fields-dialog-item.model';

@Component({
    selector: 'cmps-observation-dialog-mandatory-fields',
    templateUrl: './observation-dialog-mandatory-fields.component.html',
    host: {
        class: 'cmps-observation-dialog-mandatory-fields',
    },
})
export class ObservationMandatoryFieldsDialogComponent {
    /** @private */ _i18n = TranslationKeyMap;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            ObservationMandatoryFieldsDialogComponent,
            any
        >,
        @Inject(CMPS_DIALOG_DATA) /** @private */
        readonly _data: ObservationMandatoryFieldsDialogItem,
    ) {}
}
